import axios from 'axios';
import { jwtDecode } from 'jwt-decode';
import { backendBase } from './dataProvider';

const authProvider = {
    login: async (credentialResponse) => {
        const decoded = jwtDecode(credentialResponse.credential);
        const userData = {
            email: decoded.email,
            name: decoded.given_name,
            surname: decoded.family_name,
        };

        try {
            // Step 1: Check if user has admin role
            const adminCheckResponse = await axios.post(`${backendBase}/api/auth/check-admin-role`, userData);

            // Step 2: If admin check passes, proceed with normal login to create/update user
            const loginResponse = await axios.post(`${backendBase}/api/auth/google`, userData);

            // Store authentication data
            localStorage.setItem('token', credentialResponse.credential);
            localStorage.setItem('userId', loginResponse.data.id);
            localStorage.setItem('userRole', adminCheckResponse.data.role);
            localStorage.setItem('userEmail', adminCheckResponse.data.email);

            return Promise.resolve();
        } catch (error) {
            console.error('Admin login failed:', error);

            // Provide specific error messages based on the error type
            if (error.response?.status === 403) {
                return Promise.reject('Access denied: Admin privileges required to access this interface.');
            } else if (error.response?.status === 404) {
                return Promise.reject('User not found. Please contact support to request admin access.');
            } else if (error.response?.data?.detail) {
                return Promise.reject(error.response.data.detail);
            } else {
                return Promise.reject('Login failed. Could not connect to the server.');
            }
        }
    },
    logout: () => {
        localStorage.removeItem('token');
        localStorage.removeItem('userId');
        localStorage.removeItem('userRole');
        localStorage.removeItem('userEmail');
        return Promise.resolve();
    },
    checkAuth: () => {
        const token = localStorage.getItem('token');
        const userRole = localStorage.getItem('userRole');

        // Check if user is authenticated and has admin role
        if (token && userRole === 'admin') {
            return Promise.resolve();
        } else {
            // Clear all auth data if invalid
            localStorage.removeItem('token');
            localStorage.removeItem('userId');
            localStorage.removeItem('userRole');
            localStorage.removeItem('userEmail');
            return Promise.reject();
        }
    },
    checkError: (error) => {
        const status = error.status;
        if (status === 401 || status === 403) {
            localStorage.removeItem('token');
            localStorage.removeItem('userId');
            localStorage.removeItem('userRole');
            localStorage.removeItem('userEmail');
            return Promise.reject();
        }
        return Promise.resolve();
    },
    getIdentity: () => {
        const token = localStorage.getItem('token');
        if (token) {
            const decoded = jwtDecode(token);
            return Promise.resolve({
                id: decoded.email, // Use email as the unique ID
                fullName: decoded.name,
                avatar: decoded.picture,
            });
        }
        return Promise.reject('No token found');
    },
    getPermissions: () => Promise.resolve(),
};

export default authProvider;
